import * as React from "react";
import { Accordion } from "../../../../../../react-core/Html/Accordion";
import { CircleBtn, CircleBtnType } from "../../../../../../react-core/Html/CircleBtn";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { MoneyOrPercentageType } from "../../../../../../Wrap/Constants/Enums/MoneyOrPercentageType";
import { RestrictionTypeEnum } from "../../../../../../Wrap/Constants/Enums/RestrictionTypeEnum";
import { WhatIfToolDetailModel } from "../../../../../../Wrap/Models/Models/Processes/WhatIfTool/WhatIfToolDetailModel";
import { User } from "../../../../../../Wrap/Models/Models/User/User";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../Shared/Common/UserMessages";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { getReRegInvestment } from "../../../../../Shared/IST/Components/Shared/Utils";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { WizardLinter, EWizardLinterStatus } from "../../../../../Shared/Process/Process/WizardLinter";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Action } from "../../../../Actions/Action";
import { UserStore } from "../../../../Stroes/Variable";
import { InvestmentToWithdrawal } from "./InvestmentToWithdrawal";
import { Withdrawal } from "./Withdrawal";
import { ProductType } from "../../../../../../Wrap/Constants/Enums/Domain/ProductType";

interface IWithdrawalsProps extends IProcessComponentProps {
    modelName: string;
    type?: ProcessType;
    onBankChange?: (bank) => void;
    extraInfoWhatIf?: WhatIfToolDetailModel;
}

interface IWithdrawalsState {
    expandList: boolean[];
    withToAddWithdrawal: boolean;
    isRestrictionActive: boolean;
    userInfo: User;
}

export class Withdrawals extends ProcessComponent<IWithdrawalsProps, IWithdrawalsState> {
    constructor(props: any) {
        super(props);
        const { RegularWithdrawalModel } = this.props.data[this.props.modelName];
        this.state = {
            userInfo: UserStore.getUserInfo(),
            expandList: [true],
            withToAddWithdrawal: RegularWithdrawalModel.length > 0,
            isRestrictionActive: false,
        };
    }

    componentDidMount() {
        const { type } = this.props;
        super.componentDidMount();
        if (type != ProcessType.Quote && type != ProcessType.NB) {
            const subaccounthierarchyid = getQueryParameters()["subaccounthierarchyid"];
            Action.isAccountRestrictionActive(subaccounthierarchyid, RestrictionTypeEnum.Withdraw, (isActive) => {
                this.setState({ isRestrictionActive: isActive });
            });
        }
    }

    private addWithdrawal() {
        const { RegularWithdrawalModel } = this.props.data[this.props.modelName];
        const { expandList } = this.state;
        if (
            RegularWithdrawalModel &&
            RegularWithdrawalModel.length !== 0 &&
            !(
                this.isValidChild(RegularWithdrawalModel.length - 1) &&
                this.isValidChild(RegularWithdrawalModel.length * 2 - 1)
            )
        ) {
            return;
        }
        const _data = RegularWithdrawalModel ? RegularWithdrawalModel.concat() : [];
        _data.push({
            ClientRegularPayment: { Withdrawal: { Type: MoneyOrPercentageType.Percentage }, IsContinue: true },
            Allocations: [],
            ProportionallyAllocated: null,
        });
        this.onDataChange(
            this.props.onChange,
            { RegularWithdrawalModel: _data },
            this.props.data,
            this.props.modelName
        );
        expandList[expandList.length - 1] = false;
        expandList.push(true);
        this.setState({ expandList });
    }

    private onRemoveWithdrawal(index) {
        const { RegularWithdrawalModel } = this.props.data[this.props.modelName];
        const { expandList } = this.state;
        const _data = RegularWithdrawalModel.concat();
        _data.splice(index, 1);
        expandList.splice(index, 1);
        this.onDataChange(
            this.props.onChange,
            { RegularWithdrawalModel: _data },
            this.props.data,
            this.props.modelName
        );
        this.setState({ expandList });
    }

    private removeAllWithdrawals() {
        const { RegularWithdrawalModel } = this.props.data[this.props.modelName];
        const { expandList } = this.state;
        const _data = RegularWithdrawalModel.concat();
        this.onDataChange(
            this.props.onChange,
            { RegularWithdrawalModel: [] },
            this.props.data,
            this.props.modelName
        );
        this.setState({ expandList });
    }

    private getKeyString(modelName) {
        switch (modelName) {
            case "GiaModel":
            case "GiaQuote":
                return "GiaTransfers";
            case "IsaModel":
            case "ISAQuote":
                return "IsaTransfers";
            default:
                return "";
        }
    }

    private getProps = (datas, index, indice) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: datas,
            isReview: this.props.isReview,
            onRef: (ref) => this.appendChild(ref, indice),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => {
                const { RegularWithdrawalModel } = this.props.data[this.props.modelName];
                const _data = RegularWithdrawalModel.concat();
                const _item = _data[index];
                for (const key in changes) {
                    _item[key] = changes[key];
                }
                _data[index] = _item;
                this.onDataChange(onChange, { RegularWithdrawalModel: _data }, data, this.props.modelName);
            },
        };
    };

    public render(): JSX.Element {
        const { BankAccountInstructions, AllBankAccounts, OwnerHierarchyId } = this.props.data;
        const { RegularWithdrawalModel, InstrumentSelections } = this.props.data[this.props.modelName];
        const { isRestrictionActive } = this.state;

        let restrictedMessage = "An account with suspended or restricted activities cannot setup receive withdrawals";
        let liquidInvestmentsMessage = "You have not selected any investments which are eligible for withdrawals.";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        const reRegInstruments = getReRegInvestment(
            this.props.modelName == "IsaModel" || this.props.modelName == "ISAQuote"
                ? this.props.data[this.props.modelName].IsaTransfers
                : this.props.data[this.props.modelName].GiaTransfers,
            this.props.data.CashInstrument
        );
        const hasExistingRegularWithdrawal = RegularWithdrawalModel && RegularWithdrawalModel.length > 0;
        const hasLiquidInvestments = this.props.modelName === "Contribution" ? true : 
        this.props.data[this.props.modelName].InstrumentSelections.Instruments
            .filter((item) => item.Instrument.Type != ProductType.CashProduct)
            .some((item) => 
                item.ClientRegular.Percentage > 0 || item.ClientRegular.Money.Amount > 0 ||
                item.EmployerRegular.Percentage > 0 || item.EmployerRegular.Money.Amount > 0 ||
                item.Single.Percentage > 0 || item.Single.Money.Amount > 0 ||
                item.ThirdPartyRegular.Percentage > 0 || item.ThirdPartyRegular.Money.Amount > 0 ||
                item.Transfer.Percentage > 0 || item.Transfer.Money.Amount > 0
            );

        
        if (!hasLiquidInvestments && (RegularWithdrawalModel != null && RegularWithdrawalModel.length > 0)) {
            this.removeAllWithdrawals();
        }

        return (
            <WizardLinter status={EWizardLinterStatus.PleaseCheck}>
                <div>
                    <h2>Withdrawals</h2>
                    {isRestrictionActive && <Alert alertType={AlertType.Error} message={restrictedMessage} />}
                    {!hasLiquidInvestments && <Alert alertType={AlertType.Warning} message={liquidInvestmentsMessage} />}
                    {!hasExistingRegularWithdrawal && hasLiquidInvestments && (
                        <RadiosEditor
                            cssWrapper="rg-inline mb-20"
                            options={[true, false]}
                            getText={(v) => (v ? "Yes" : "No")}
                            disabled={isRestrictionActive}
                            label="Do you wish to add a withdrawal?"
                            selected={RegularWithdrawalModel.length > 0}
                            onChange={(v) => {
                                const expandList = [];
                                if (v) {
                                    if (RegularWithdrawalModel.length === 0) {
                                        RegularWithdrawalModel.push({
                                            ClientRegularPayment: {
                                                Withdrawal: { Type: MoneyOrPercentageType.Percentage },
                                                IsContinue: true,
                                            },
                                            Allocations: [],
                                            ProportionallyAllocated: null,
                                        });
                                    }
                                    if (RegularWithdrawalModel) {
                                        const len = RegularWithdrawalModel.length;
                                        if (len === 1) {
                                            expandList.push(true);
                                        } else {
                                            for (let i = 0; i < len; i++) {
                                                expandList.push(false);
                                            }
                                        }
                                    }
                                    this.setState({ expandList });
                                } else {
                                    this.onDataChange(
                                        this.props.onChange,
                                        { RegularWithdrawalModel: [] },
                                        this.props.data,
                                        this.props.modelName
                                    );
                                }
                                this.setState({ withToAddWithdrawal: v, expandList: expandList });
                            }}
                        />
                    )}

                    {RegularWithdrawalModel &&
                        RegularWithdrawalModel.length > 0 &&
                        this.state.withToAddWithdrawal &&
                        RegularWithdrawalModel.map((ele, index) => {
                            let existingWithdrawal = null;
                            if (this.props.type === ProcessType.WhatIf) {
                                existingWithdrawal = this.props.extraInfoWhatIf?.RegularWithdraws?.[index];
                            }
                            return (
                                <>
                                    <Accordion
                                        key={`Withdrawal - ${index + 1}`}
                                        label={`Withdrawal ${index + 1}`}
                                        // onRemove={() => this.onRemoveWithdrawal(index)}
                                        onChange={(v) => {
                                            if (v) {
                                                const { expandList } = this.state;
                                                const _expandList = expandList.concat();
                                                _expandList[index] = true;
                                                this.setState({ expandList: _expandList });
                                            }
                                            return v
                                                ? v
                                                : this.isValidChild(index) &&
                                                      this.isValidChild(RegularWithdrawalModel.length + index);
                                        }}
                                        isOpen={this.state.expandList[index]}
                                        cssWrapper="accordion-simple"
                                    >
                                        <Withdrawal
                                            {...this.getProps(ele, index, index)}
                                            key={`RegWithdrawal - ${index}`}
                                            type={this.props.type}
                                            bankAccountInstruction={BankAccountInstructions}
                                            allBankAccounts={AllBankAccounts}
                                            ownerId={OwnerHierarchyId}
                                            onBankChange={this.props.onBankChange}
                                            instruments={InstrumentSelections?.Instruments}
                                            model={this.props.data[this.props.modelName]}
                                            keyString={this.getKeyString(this.props.modelName)}
                                            reRegInvestments={reRegInstruments}
                                            existingWithdrawal={existingWithdrawal}
                                        />
                                        <InvestmentToWithdrawal
                                            key={`InvestmentToWithdrawal - ${index}`}
                                            {...this.getProps(ele, index, RegularWithdrawalModel.length + index)}
                                            instruments={InstrumentSelections?.Instruments}
                                            model={this.props.data[this.props.modelName]}
                                            type={this.props.type}
                                            keyString={this.getKeyString(this.props.modelName)}
                                            reRegInstruments={reRegInstruments}
                                        />
                                        <CircleBtn
                                            type={CircleBtnType.remove}
                                            cssWrapper="mr-52"
                                            title="Remove this withdrawal"
                                            onClick={() => this.onRemoveWithdrawal(index)}
                                        />
                                        {index == RegularWithdrawalModel.length - 1 && (
                                            <CircleBtn
                                                type={CircleBtnType.add}
                                                title="Add another withdrawal"
                                                onClick={() => this.addWithdrawal()}
                                            />
                                        )}
                                    </Accordion>
                                </>
                            );
                        })}
                </div>
            </WizardLinter>
        );
    }
}
